import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSignupScreen from './AbstractStartSignupScreen';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';

export default class EduSignupScreen extends AbstractStartSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-edu';

  public override async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.intent = UnifiedSignupIntent.eduIntent;
    return super.toNextScreen();
  }

  public predicate(): boolean {
    return (
      this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.eduPlan) &&
      this.sessionInfo.value.emailCheckCode === null
    );
  }
}
